// =====================================================================
// Filtro de Sentry: el chunk obsoleto que llega como index.html
// =====================================================================
// Tras un deploy, una pestaña abierta con el build viejo pide un chunk que ya no
// existe; CloudFront responde con index.html y el navegador intenta ejecutar
// "<!doctype html>" como JS. Eso genera DOS señales, y solo una sirve:
//
//   - El SyntaxError lo levanta el handler global de errores de script, en
//     paralelo al rechazo de la promesa que `lazyWithRetry` sí captura y del que
//     recupera al usuario recargando. No hay nada que hacer con él y se repetiría
//     en cada deploy por cada pestaña que quedó abierta.
//   - El ChunkLoadError, en cambio, solo llega a Sentry cuando el reintento de
//     `lazyWithRetry` YA falló y el usuario quedó en el ErrorBoundary. Ese sí hay
//     que verlo, así que NO se filtra.
//
// ⚠️ Dónde está la ruta del chunk. La primera versión (92b05b4d) la buscaba en
// `originalException.filename` y en `event.culprit`, y no la encontraba nunca:
// `filename` es del ErrorEvent del navegador, no del SyntaxError que llega como
// `originalException`, y el SDK no llena `culprit` (lo calcula Sentry en el
// servidor). El filtro no descartó nada durante tres meses (JAVASCRIPT-REACT-4,
// 25 eventos). La ruta viaja en los frames del stacktrace del evento, y de ahí se
// lee ahora; `filename` del error se conserva por si algún navegador lo trae.

// El mensaje ENTERO, anclado. Sin anclas también caería el `JSON.parse` de una
// respuesta HTML (Chrome: `Unexpected token '<', "<!doctype "... is not valid
// JSON`), que sale de nuestro chunk y sí es una señal: la API devolvió HTML.
const MENSAJE_HTML = /^(Unexpected token '<'|expected expression, got '<')$/;
const RUTA_DE_CHUNK = /\/static\//;

function rutasDelEvento(event) {
  const rutas = [];
  for (const excepcion of event?.exception?.values || []) {
    for (const frame of excepcion?.stacktrace?.frames || []) {
      if (frame?.filename) rutas.push(frame.filename);
      if (frame?.abs_path) rutas.push(frame.abs_path);
    }
  }
  return rutas;
}

export function esHtmlServidoComoJs(event, hint) {
  const err = hint?.originalException;
  const msg = (typeof err === "string" ? err : err?.message) || "";
  const tipo = err?.name || event?.exception?.values?.[0]?.type;
  if (tipo !== "SyntaxError" || !MENSAJE_HTML.test(msg)) return false;
  const rutas = [err?.filename || "", ...rutasDelEvento(event)];
  return rutas.some((ruta) => RUTA_DE_CHUNK.test(ruta));
}

export function beforeSend(event, hint) {
  return esHtmlServidoComoJs(event, hint) ? null : event;
}
